import styled from '@emotion/styled';

export const FrameList = styled.div`
  display: flex;
  position: relative;
  justify-content: center;
  max-width: 500px;
  height: 100%;
  > div {
    width: 180px;
    height: 270px;
    position: absolute;
    > img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
`;

export const FrameGridContainer = styled.div`
  width: 564px;
  height: 572px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(3, 1fr);
  justify-items: center;
`;

export const FrameItem = styled.div<{ selected: boolean; isEmpty: boolean }>`
  width: 120px;
  height: 180px;
  border-radius: 8px;
  cursor: ${({ isEmpty }) => (isEmpty ? 'default' : 'pointer')};
  transition: all 0.2s ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ isEmpty, theme }) => (isEmpty ? theme.color[6] : 'transparent')};
  opacity: ${({ isEmpty, selected }) => {
    if (selected) return 0.3;
    if (isEmpty) return 0;
    return 1;
  }};
  box-shadow: 0px 4px 4px 0px #00000040;

  &:hover {
    border-color: ${({ isEmpty, selected, theme }) =>
      isEmpty ? 'transparent' : selected ? theme.color[3] : theme.color[5]};
  }

  > img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .empty-frame {
    width: 80%;
    height: 80%;
    background-color: ${({ theme }) => theme.color[7]};
    border-radius: 4px;
  }
`;

export const DirectionBox = styled.div`
  width: 80px;
  height: 80px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ChooseFrameBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  overflow-y: auto;
`;

export const DashedBox = styled.div`
  width: 780px;
  height: 600px;
  position: relative;
  border-radius: 12px;
  border: 4px dashed ${({ theme }) => theme.color[3]};
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  max-width: 1280px;
  max-height: 773px;
  padding: 28px 33px 32px 33px;
  gap: 30px;
`;

export const FrameSelectGuideText = styled.p`
  ${({ theme }) => theme.typography.BOLD_60};
  color: ${({ theme }) => theme.color[2]};
  line-height: 100px;
  margin-bottom: 12px;
`;

export const FramePreviewBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  > img {
    margin-bottom: 12px;
  }

  > p {
    margin-top: 4px;
    text-decoration: underline;
    ${({ theme }) => theme.typography.REGULAR_12};
    color: ${({ theme }) => theme.color[2]};
    cursor: pointer;
    opacity: 0;
  }
`;
